import { ApplicationConfig } from '@angular/core'
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http'
import { provideRouter, TitleStrategy } from '@angular/router'

import { BrandTitleStrategy } from './services/brand-title.strategy'

import { routes } from './app.routes'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { httpInterceptorProviders } from './providers'

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    { provide: TitleStrategy, useClass: BrandTitleStrategy },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAnimationsAsync(),
    httpInterceptorProviders,
  ],
}
